import React, {useEffect, useRef, useMemo, useState} from 'react'; // useImperativeHandle

import {validateExtraConditions} from 'ultra/helpers/content';
import {isEmptyObj} from 'ultra/helpers/utils';
import {ignoreTextFieldKeys} from "ultra/helpers/utils";

import InputAdornment from '@mui/material/InputAdornment';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import {useFormStore} from '../../../Stores/form';

import TextFieldInput from '../Text';

import './index.scss';

const symbolRegExp = new RegExp('[\\s]$')

export default function NumberFormField(props) {
    const {content, disabled, field, isEditMode, onBlur} = props;
    // onChange

    const {formVisibleErrors, setFormField} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [InputProps, setInputProps] = useState({});

    const [regexpHighlight, setRegexpHighlight] = useState(false)

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => { setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    // const [prevValue, setPrevValue] = useState();
    const [cursorPosition, setCursorPosition] = useState(0); // content[field.id]?.length || 0
    const [formatedValue, setFormatedValue] = useState(""); // getFormatedCurrency(content[field.id])
    const [error, setError] = useState(null);

    const inputRef = useRef(null);

    useEffect(() => {
        const p = field?.options?.prefix
        const s = field?.options?.sufix

        const params = {}
        if (p) params.startAdornment = <InputAdornment position="start">{p}</InputAdornment>
        if (s) params.endAdornment = <InputAdornment position="start">{s}</InputAdornment>
        setInputProps(params)
    }, [field])

    useEffect(() => {
        setFormatedValue(getFormatedCurrency(content[field.id]));
        // if (!content[field.id]) {
        //     setFormatedValue("")
        // }
        // else if (Number.isInteger(content[field.id])) {
        //     setFormatedValue(getFormatedCurrency(content[field.id]));
        // }
        // else {
        //     setFormatedValue(getFormatedCurrency(content[field.id].toFixed(2)));
        // }

        // if (!content[field.id]) {
        //     setCursorPosition(0);
        // }
        // else {
        //     const result = getFormatedCurrency(content[field.id]);
        //     let cursor = cursorPosition;

        //     const spacesDiff = (result?.match(/\s/g)?.length || 0) - (prevValue?.match(/\s/g)?.length || 0);
        //     // const isBackspace = prevValue.replace(/[^0-9\.\,]+/g,'').length > result.replace(/[^0-9\.\,]+/g,'').length;
        //     cursor += spacesDiff;

        //     if (cursor < 0) cursor = 0;

        //     setCursorPosition(cursor);
        // }
        if (!content[field.id]) setCursorPosition(0)
    }, [content[field.id]])

    const className = useMemo(() => {
        let result = "NumberField";
        result += content[field.id] ? ' filled' : ''
        return result;
    }, [content[field.id]])

    useEffect(() => {
        const ref = inputRef?.current?.querySelector('input[type=text]');
        if (ref && document.activeElement === inputRef?.current) ref.setSelectionRange(cursorPosition, cursorPosition);
    }, [cursorPosition])

    const onChangeWrapper = e => {
        setError(null);
        // onChange(e);
        setFormField(field.id, e.target.value)
    }

    const onBlurHandler = e => {
        const errors = validateExtraConditions({[field.id]: field}, {[field.id]: content[field.id]})
        if (!isEmptyObj(errors)) {
            setError(errors[field.id]);
        }
        if (onBlur) onBlur(e);
    }

    if (props.field?.options?.format === "currency") {
        const formatedRegexp = "Доступні для вводу символи: числа (0-9) та символи , .";

        return (<Grid key={field?.id} item xs={12}>
            <TextField
                label={field?.placeholder}
                variant="outlined"
                fullWidth
                required={field?.required}
                disabled={isDisabled}

                className={className}

                ref={inputRef}

                // value={content[field.id] ? true : undefined}   // it's here to move placeholder on first render to top

                error={(Boolean(regexpHighlight|| error || showErrorText))}
                helperText={(regexpHighlight ? formatedRegexp : false) || error || showErrorText}
                
                InputProps={{
                    ...InputProps,
                    inputComponent: NumericFormatField,
                    inputProps: {
                        formatedValue: formatedValue,
                        onKeyUp: e => {
                            const regex = field.options.regexp || new RegExp("^[0-9\.\,]*$");
                            if (((e.ctrlKey || e.metaKey) && e.key === 'v') || e.key === 'Enter') {
                                if (!ignoreTextFieldKeys(e) && !regex.test(e?.target?.value)) {
                                    setRegexpHighlight(true);
                                }
                                else {
                                    setRegexpHighlight(false);
                                }

                                return false;
                            }

                            if (!ignoreTextFieldKeys(e) && !regex.test(e.key)) {
                                setRegexpHighlight(true);
                            }
                            else {
                                setRegexpHighlight(false);
                            }
                        },
                        onBlur: onBlurHandler,
                        onChange: e => {
                            let v = (e.target.value || '');

                            let cleanedStringValue = v.replace(/[^0-9\.\,]+/g,'');

                            let separator = cleanedStringValue.includes(",") ? "," : ".";

                            cleanedStringValue = cleanedStringValue.replaceAll(",", ".");

                            let cursor = e.target.selectionStart;
                            const prev = content[field.id] ? new Intl.NumberFormat("uk-UA", {}).format(content[field.id]) : "";
                            const isDec = prev.length > v.length;

                            if (isDec && symbolRegExp.test(prev[cursor])) {
                                e.preventDefault();
                                return;
                            }

                            // if (!isDec) console.log('it growth');

                            // if (isDec && symbolRegExp.test(prev[cursor])) {
                            //     cursor -= 1;
                            // }
                
                            const result = getFormatedCurrency(cleanedStringValue);

                            if (!content[field.id]) {
                                setCursorPosition(0);
                            }
                            else {
                                // const ref = inputRef?.current?.querySelector('input[type=text]');
                                // let cursor = ref.selectionStart;
                                
                                const spacesDiff = (result?.match(/\s/g)?.length || 0) - (v?.match(/\s/g)?.length || 0);
                                // const isChanged = parseFloat(cleanedStringValue) !== content[field.id];

                                // // empty space delated
                                // if (spacesDiff > 0 && !isChanged) {
                                //     cursor -= 1;
                                // }
                                // else {
                                //     cursor += spacesDiff;
                                // }
                                cursor += spacesDiff;
                                if (cursor < 0) cursor = 0;
                    
                                setCursorPosition(cursor);
                            }

                            if (cleanedStringValue && cleanedStringValue[0] !== separator) {
                                setFormatedValue(result);
                                onChangeWrapper({target: {value: parseFloat(cleanedStringValue)}});
                            }
                            else {
                                setFormatedValue("");
                                onChangeWrapper({target: {value: undefined}});
                            }
                        }
                    }
                }}
            />
            {!(error || showErrorText) && field?.notes && <div className="fieldNotes">
                <p>{field?.notes}</p>
            </div>}
        </Grid>)
    }

    props.field.options = props.field.options || {};
    props.field.options.regexp = props.field.options.regexp || '^[0-9\.\,]*$';
    return <TextFieldInput {...props} className={className} onBlur={onBlurHandler} inputMode="decimal"/>
}

function getFormatedCurrency(value) {
    if (!value) return "";

    const separator = ".";

    let v = value.toString()

    let sufix = "";
    if (v.indexOf(separator) > -1) {
        const parts = v.split(separator);
        v = parts[0];

        sufix = separator;

        const s = parts[1].replace(/[^0-9\.\,]+/g,'');

        if (s) {
            if (s.length > 2) {
                sufix += + s.substring(0, 2);
            }
            else {
                sufix += s;
            }
        }
    }

    const formatedIntPart = new Intl.NumberFormat("uk-UA", {}).format(parseInt(v))
    const formatedValue = formatedIntPart + sufix;

    return formatedValue;
}

const NumericFormatField = React.forwardRef(NumericFormat)

function NumericFormat(props, ref) {   
    // useImperativeHandle(ref, () => ({
    //     test: () => {
    //         console.log('test')
    //     },
    // }));

    const {onKeyUp, formatedValue, ...other} = props;
 
    const inputRef = useRef(null);
        useEffect(() => {
            inputRef?.current?.addEventListener('keyup', onKeyUp);
            return () => { inputRef?.current?.removeEventListener('keyup', onKeyUp) };
    }, []);

    return <input
        {...other}
        inputMode="decimal"
        value={formatedValue}
        ref={inputRef}
    />;
}
